<template>
  <div>
    <el-table
      :data="items"
      v-loading="loading"
      size="small"
      class="mt-10"
      border
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <div style="padding: 0 10px">
            <el-table border :data="props.row.records" size="mini">
              <el-table-column align="center" label="数据类型">
                <template slot-scope="scope">
                  {{ scope.row.category == 6 ? '维修记录' : '使用记录' }}
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="日期"
                prop="created_at_human"
              >
                <template slot-scope="scope">
                  {{ $time(scope.row.used_date).format('YYYY-MM-DD') }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="工作时长" prop="used_hour">
                <template slot-scope="scope">
                  {{ scope.row.category == 6 ? '-' : scope.row.used_hour }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="使用区块">
                <template slot-scope="scope">
                  {{
                    scope.row.category == 6
                      ? '-'
                      : scope.row.used_extra[0].value
                  }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="井队号">
                <template slot-scope="scope">
                  {{
                    scope.row.category == 6
                      ? '-'
                      : scope.row.used_extra[1].value
                  }}
                </template>
              </el-table-column>
              <el-table-column align="center" label="井号">
                <template slot-scope="scope">
                  {{
                    scope.row.category == 6
                      ? '-'
                      : scope.row.used_extra[2].value
                  }}
                </template>
              </el-table-column>
              <el-table-column
                align="left"
                label="备注/图片/视频"
                min-width="140"
              >
                <template slot-scope="scope">
                  <div v-html="scope.row.remark.split('<br/>').pop()"></div>
                  <div class="medio-container">
                    <el-image
                      v-for="url in scope.row.imgs"
                      :key="url"
                      style="width: 30px; height: 30px; margin-right: 5px"
                      :src="url"
                      :preview-src-list="scope.row.imgs"
                    >
                    </el-image>
                    <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="配件编号(分类)">
        <template slot-scope="scope"
          >{{ scope.row.code }}（{{ scope.row.name }}）</template
        >
      </el-table-column>
      <el-table-column align="center" label="使用次数" prop="used_count">
      </el-table-column>
      <el-table-column align="center" label="维修次数" prop="repair_count">
      </el-table-column>
      <!-- <el-table-column align="left" label="备注/图片/视频" min-width="140">
        <template slot-scope="scope">
          <div v-html="scope.row.remark.split('<br/>').pop()"></div>
          <div class="medio-container">
            <el-image
              v-for="url in scope.row.imgs"
              :key="url"
              style="width: 30px; height: 30px; margin-right: 5px"
              :src="url"
              :preview-src-list="scope.row.imgs"
            >
            </el-image>
            <VideoPlayer :srcs="scope.row.videos"></VideoPlayer>
          </div>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>